import LinkCard from '../layout/LinkCard';
import classes from './Portfolio.module.scss';

import { Navigation, Pagination, A11y } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import MediaQuery from 'react-responsive';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// hardcoded for now
const PORTFOLIO_ITEMS = [
  {
    title: "Audiophile",
    image: require('assets/images/audiophile.jpg'),
    link: "https://audiophile-fe-mentor.web.app/",
    githubLink: "https://github.com/mjbaga/audiophile-ecommerce-react",
    description: "This project was done with React, where I used more tools like Redux for state, Tailwind for styling, Firebase's Firestore for its NoSQL database and Firebase Cloud Storage for images."
  },
  {
    title: "Designo",
    image: require('assets/images/designo.jpg'),
    link: "https://mjbaga.github.io/designo-react/",
    githubLink: "https://github.com/mjbaga/designo-react",
    description: "Designo was built with React and its design is a great way to showcase building layouts and components. I also used Sass as it works well with components. Leaflet JS was utilized for maps."
  },
  {
    title: "Space Tourism",
    image: require('assets/images/space-tourism.jpg'),
    link: "https://mjbaga.github.io/space-tourism-react/",
    githubLink: "https://github.com/mjbaga/space-tourism-react",
    description: "Space tourism is built with React and is a simple website where I've implemented simple components, a hybrid of moduled and utility styling."
  }
]

const Portfolio = () => {

  return (
    <section className={`${classes.portfolio} pg-page`} name="portfolio" id="portfolio">
      <div className="container">
        <h2 className='section-title white center'>Portfolio</h2>
        <div className={classes["portfolio-items"]}>
          <MediaQuery maxWidth={1023}>
            <Swiper
              modules={[Navigation, Pagination, A11y]}
              slidesPerView={1}
              navigation
              pagination={{ clickable: true }}
              allowTouchMove={true}
            >
              {PORTFOLIO_ITEMS.map((item, i) => (<SwiperSlide key={i}><LinkCard {...item} key={i} /></SwiperSlide>))}
            </Swiper>
          </MediaQuery>
          <MediaQuery minWidth={1024}>
            {PORTFOLIO_ITEMS.map((item, i) => (<LinkCard {...item} key={i} />))}
          </MediaQuery>
        </div>
        <p className={classes.attribution}><em>The portfolio website designs have been availed from <a href="https://www.frontendmentor.io/" target="_blank" rel="noreferrer">Frontend Mentor</a> that offer them as challenges for web developers.</em></p>
      </div>
    </section>
  )
}

export default Portfolio;